import provinces from '../../../static/china/provinces.json'
import cities from '../../../static/china/cities.json'
import areas from '../../../static/china/areas.json'
import streets from '../../../static/china/streets.json'

// 更换皮肤集合
const styleList = [
  { value: 'one', label: '赤诚红', imgs: '../../static/img/red.png' },
  { value: 'two', label: '经典蓝', imgs: '../../static/img/blue.png' },
  { value: 'three', label: '叶兰绿', imgs: '../../static/img/green.png' },
  { value: 'four', label: '玉烟紫', imgs: '../../static/img/violet.png' },
  { value: 'five', label: '芙蕖粉', imgs: '../../static/img/Pink.png' },
  { value: 'six', label: '露莓黑', imgs: '../../static/img/black.png' },
  { value: 'customColor', label: '自定义', imgs: '../../static/img/green.png' }
]
// 中国省级（省份、直辖市、自治区），地级（城市），县级（区县），乡级（乡镇、街道），村级（村委会、居委会）
const chinaList = {
  provinces: provinces,
  cities: cities,
  areas: areas,
  streets: streets
}
export default {
  styleList,
  chinaList
}
